import { User } from '../types';

// İtalya Üniversiteleri - Şirketin Çalıştığı Tüm Üniversiteler
export const allUniversities = [
  'Politecnico di Milano',
  'Università Bocconi',
  'Università Statale Milano', 
  'Università Cattolica del Sacro Cuore',
  'Università di Roma La Sapienza',
  'Università di Bologna',
  'Università di Padova',
  'Università di Firenze',
  'Università di Torino',
  'Università di Napoli Federico II',
  'Università di Pisa',
  'Università di Genova',
  'Università Ca\' Foscari Venezia',
  'Università di Perugia',
  'Università di Siena',
  'Università di Palermo',
  'Università di Bari',
  'Università di Catania',
  'Università di Verona',
  'Università di Trieste',
  'Università di Parma',
  'Università di Modena e Reggio Emilia',
  'Università di Ferrara',
  'Università di Urbino',
  'Università di Salerno',
  'Università di Lecce',
  'Università di Brescia',
  'Università di Bergamo',
  'Università di Trento'
];

// Danışman-üniversite eşleştirme fonksiyonu
export const findResponsibleConsultants = (
  selectedUniversities: string[],
  consultants: User[]
): string[] => {
  const responsibleConsultants: string[] = [];
  
  selectedUniversities.forEach(university => {
    consultants.forEach(consultant => {
      if (
        consultant.role === 'unit' && 
        consultant.unitType === 'education_consultant' &&
        consultant.responsibleUniversities?.includes(university) &&
        !responsibleConsultants.includes(consultant.name)
      ) {
        responsibleConsultants.push(consultant.name);
      }
    });
  });
  
  return responsibleConsultants;
};

// Tüm İtalyan üniversitelerini getir
export const getAllUniversities = (): string[] => {
  return allUniversities;
};

// Danışman yük dağılımı hesaplama
export const getConsultantWorkload = (
  consultantName: string,
  allStudents: any[]
): {
  totalStudents: number;
  activeStudents: number;
  completedApplications: number;
  workloadPercentage: number;
} => {
  const consultantStudents = allStudents.filter(student => 
    student.assignedConsultants.includes(consultantName)
  );
  
  const activeStudents = consultantStudents.filter(student => 
    ['lead', 'contacted', 'interested', 'applied'].includes(student.status)
  ).length;
  
  const completedApplications = consultantStudents.filter(student => 
    ['accepted', 'enrolled'].includes(student.status)
  ).length;
  
  // Maksimum 50 öğrenci kapasitesi varsayımı
  const maxCapacity = 50;
  const workloadPercentage = (consultantStudents.length / maxCapacity) * 100;
  
  return {
    totalStudents: consultantStudents.length,
    activeStudents,
    completedApplications,
    workloadPercentage: Math.min(workloadPercentage, 100)
  };
};